/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useContext } from 'react';
// Context
import { FormDataContext } from 'globalState/FormDataContext';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import Radios from 'components/shared/FormElements/Radios/Radios';
import InsetText from 'components/shared/InsetText/InsetText';

const EnquirySelection = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register, handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const radioButtons = [
    { text: 'The Mayor', value: 'mayor' },
    { text: 'A general enquiry', value: 'general' },
    { text: 'WMCA strategy', value: 'strategy' },
    { text: 'Freedom of information, whistleblowing and fraud, jobs at WMCA', value: 'other' },
  ];

  const [formDataState] = useContext(FormDataContext);
  const { EnquiryType } = formDataState.formData;
  const { MayorEnquiry } = formDataState.formData;
  const { StrategyEnquiry } = formDataState.formData;

  // Make mayor enquiry null so it hides event info on other paths
  if (EnquiryType !== 'mayor' && MayorEnquiry != null) {
    formDataState.formData.MayorEnquiry = null;
  }

  // Make strategy enquiry null so it hides on other paths
  if (EnquiryType !== 'strategy' && StrategyEnquiry != null) {
    formDataState.formData.StrategyEnquiry = null;
  }

  // Add InsetText with extra info when selected option is "no"
  let extraInfo;
  const selectedOption = document.querySelector(
    'input.wmcads-fe-radios__input[name="Enquiry"]:checked'
  );
  if (selectedOption && selectedOption.value === 'no') {
    extraInfo = (
      <InsetText
        classes="wmcads-m-b-lg"
        content="You can always sign up to email alerts later in the disruption alerts dashboard."
      />
    );
  }

  const title = 'What is your enquiry about?';

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">{title}</h2>
        </legend>

        <Radios
          name="EnquiryType"
          radios={radioButtons}
          fieldValidation={register({
            required: `Please select one option to proceed`,
          })}
        />

        {extraInfo}
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default EnquirySelection;
